import type { FaireProductEntity } from "../../entity_types/product";

export const p_u3fcq7r777: FaireProductEntity = {
  token: "p_u3fcq7r777",
  type: "product",
  name: "Vintage Style Pearl Ring-Gold Victorian Ring-Heirloom Ring",
  brandToken: "b_9k8cb79ew4",
  brandName: "Blueyejewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/268181f5eb7b1fd5a929ea2dc2ea69dbd9534451b9c3ae912dc4f89ada3ff488.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/55d9501d5d9e7f6e951def80c718168de9ecf132f1c3831354db8128ab04dfa1.jpeg",
    "https://cdn.faire.com/fastly/85cff6bc75ec1a9b60e5af9dc46eaa9657381981ffaf3163cfa2533854816095.jpeg",
    "https://cdn.faire.com/fastly/57ead09867696b5a6bcaa3ab3fdb082bba1bc94b7dcf8c9f597b7d0e4d6028e6.jpeg",
  ],
  priceDollars: 13.15,
  description:
    "***For US customers: No surprise tariff or brokerage fees. Any fees shown at checkout are fully covered upfront, with no extra charges on delivery. We take care of everything so customs is seamless for you.\n\nStunning Victorian Style Ring with a pearl centerpiece. Crafted in stainless steel, this ring is tarnish-proof and made to last. \n\nMaterial: Stainless Steel\nStone: Pearl\nFinish: 18k PVD Plated\nBand Color: Gold\nSizes: 6-7-8\n\nFREE RETAIL-READY PACKAGING\nEach item is carefully packaged for a polished presentation. Earrings come on off-white square cards featuring our logo (BEJ or Blueye Jewelry) and the material (stainless steel or sterling silver). Necklaces and bracelets are packaged on small cards with our brand name on the front and material on the back, then placed in long white polybags. Rings are packaged WITHOUT cards in zipped bags with size stickers.\n\nIf you prefer to use your own cards, please let us know, and we will package your items without using our branded cards.\n\n*We offer personalization. Please contact us to customize your pieces.",
  tags: [],
  msrpDollars: 26.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:33.352Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
